








































export default function (Component) {
  Component.options.__source = "src/module/master-data/views/components/explorer-support/cmp-md-dict-attr-floating-filter.vue"
}
